<template>
  <div class="social-follow-icons">
    <SocialButton
      link="https://www.facebook.com/RedBull/"
      iconName="facebook"
    />
    <SocialButton
      link="https://twitter.com/redbull"
      iconName="twitter"
    />
    <SocialButton
      link="https://www.instagram.com/redbull/?hl=en"
      iconName="instagram"
    />
    <div class="social-follow-icons__bar" />
    <p class="social-follow-icons__callout">
      {{ctaCopy}}
    </p>
  </div>
</template>

<script>
import SocialButton from './../components/social-button';
import { CONTENT_HERO_FOLLOW_CTA } from '../../design-tokens/build/dictionary';

export default {
  name: 'social-follow-icons',
  components: {
    SocialButton
  },
  data() {
    return {
      ctaCopy: CONTENT_HERO_FOLLOW_CTA,
    };
  }
};
</script>

<style lang="scss">
.social-follow-icons {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: $size-height-social-icon-container;
  &__bar {
    height: $size-height-social-bar;
    width: $size-width-social-bar;
    background-color: $color-base-white-base;
    opacity: .5;
  }
  &__callout {
    @include body-copy-x-small;
    color: $color-base-white-base;
    height: $size-height-social-callout;
    transform: rotate(90deg)
               translate($size-translate-social-callout-x, $size-translate-social-callout-y);
  }
  &:after {
    content: "";
    width: 0.5rem;
    height: 100%;
    position: absolute;
    background: $color-base-ninja-yellow-base;
    margin-left: 6.5rem;
    margin-top: 1rem;
  }

  @media screen and (max-width: 89.9375em) and (min-width: 59.375em) {
    &:after {
      margin-left: 3.5rem;
    }
  }
}
</style>
